module.exports = __webpack_public_path__ + "static/media/Icon-Skill.c81fc51e.svg";